/**
 * WP1.6 — two-sided consent. The matched supplier accepts or declines each
 * match; chat between the companies opens only after it accepts.
 * Backend: `MatchResult.supplier_consent` (`consentStatus` on the wire).
 */
import i18n from "../i18n";

export type SupplierConsentStatus = "pending" | "accepted" | "declined";

export type ConsentAudience = "buyer" | "supplier" | "moderator";

export type ConsentVariant = "warning" | "success" | "danger";

function normalize(status: string | null | undefined): SupplierConsentStatus {
  return status === "accepted" || status === "declined" ? status : "pending";
}

export function consentLabel(status: string | null | undefined, audience: ConsentAudience): string {
  return i18n.t(`domain:consent.${audience}.${normalize(status)}`);
}

export function consentVariant(status: string | null | undefined): ConsentVariant {
  const s = normalize(status);
  return s === "accepted" ? "success" : s === "declined" ? "danger" : "warning";
}

/** Chat can be opened only for deals the supplier accepted. */
export function canOpenChat(status: string | null | undefined): boolean {
  return normalize(status) === "accepted";
}

/** Tooltip / helper text for the buyer's disabled "Initiate Contact". */
export function chatBlockedHint(status: string | null | undefined): string | null {
  const s = normalize(status);
  if (s === "accepted") return null;
  return i18n.t(s === "declined" ? "domain:consent.chatBlocked.declined" : "domain:consent.chatBlocked.pending");
}
